class Register extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form[data-cf-form]");
  }
  connectedCallback() {
    this.toggleVisiblePassword();
    this.returnIcon();
    if (CF) {
      CF.ready(() => {
        if (localStorage && localStorage.getItem("re_e")) {
          this.form.cfForm.setFieldValue("email", atob(localStorage.getItem("re_e")));
        }
        this.form.cfForm.beforeSave(() => {
          this.unsetRegistrationEmail(this.form.cfForm);
        });
      });
    }
  }
  unsetRegistrationEmail() {
    if (localStorage && localStorage.getItem("re_e")) {
      localStorage.removeItem("re_e");
    }
  }
  toggleVisiblePassword() {
    const eyeOpenIcon = `
            <div class="u-absolute u-flex align-items-center show-password">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
            </div>
        `;
    const eyeOpenWrapper = document.createElement("div");
    eyeOpenWrapper.innerHTML = eyeOpenIcon;
    const eyeOpenElement = eyeOpenWrapper.firstElementChild;
    const eyeClosedIcon = `
            <div class="u-absolute u-flex align-items-center hide-password" style="display: none">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye-off"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M1 1l22 22"/></svg>
            </div>
        `;
    const eyeClosedWrapper = document.createElement("div");
    eyeClosedWrapper.innerHTML = eyeClosedIcon;
    const eyeClosedElement = eyeClosedWrapper.firstElementChild;
    const form = document.querySelector("form#create_customer");
    document.addEventListener("cf:ready", function() {
      const passwordElement = form.querySelector('.cf-field[data-cf-field-type="password"]');
      passwordElement.appendChild(eyeOpenElement);
      passwordElement.appendChild(eyeClosedElement);
      const input = passwordElement.querySelector("input");
      const eyeOpen = passwordElement.querySelector(".show-password");
      const eyeClosed = passwordElement.querySelector(".hide-password");
      eyeOpen.addEventListener("click", (e) => {
        e.preventDefault();
        input.type = "text";
        eyeClosed.style.display = "flex";
        eyeOpen.style.display = "none";
      });
      eyeClosed.addEventListener("click", (e) => {
        e.preventDefault();
        input.type = "password";
        eyeOpen.style.display = "flex";
        eyeClosed.style.display = "none";
      });
    });
  }
  /**
   * When the user clicks on the return icon, the browser will go back to the previous page.
   */
  returnIcon() {
    const icon = this.querySelector(".js-return-icon");
    icon.addEventListener("click", (e) => {
      e.preventDefault();
      window.history.back();
    });
  }
}
customElements.define("w3-register", Register);
